module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"withoutSaving":{"title":"Leaving without saving","text":"Are you sure that you that really want to leave without saving?","yes":"Yes","no":"No"}},"cs":{"withoutSaving":{"title":"Změny nejsou uloženy","text":"Opravdu se chcete vrátit bez uložení nových změn?","yes":"Ano","no":"Ne"}}}')
  delete Component.options._Ctor
}
